module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pg-cc474d6d88bc8b18d7eb9287e608ca36.svg";